import { Grid, useEventCallback } from '@mui/material';
import { CodeSection } from 'civil-status/constants/code-subject-section';
import { STATES_ACT } from 'civil-status/constants/states-act';
import {
  CommunicationVM,
  DataWizardAct,
  Evento,
  LastStepVM,
  ParentVM,
  RecapVM,
  SectionVM,
  SignatureActUscVM,
  SignatureActVM,
  StepVM,
  TextActVM,
  ViewStepVM,
} from 'civil-status/view-models/step-form';
import { FormikProps, FormikTouched } from 'formik';
import { Fragment, memo, useEffect, useMemo, useState } from 'react';
import { PmiButton } from 'shell/components/shared/button';
import { ResponsePromise } from 'shell/hooks/use-http-fetch/stateless/type';
import { touchedSection, touchedSubject } from 'civil-status/constants/touched-section-subject';
import { KeySections } from 'civil-status/constants/keys-subjects-section';
import { generatePath, useNavigate } from 'react-router-dom';
import { useHttpClient } from 'shell/hooks/use-http-fetch/stateless';
import { __ACT_API_URL__ } from 'shell/constants/environment';
import { toast } from 'react-toastify';
import DeleteAlertModal from 'system/components/shared/delete-alert';
import { HttpResponse } from 'shell/models/http-response';
import { idStateDocumentWizard } from 'civil-status/constants/id-state-document-wizard';
import { transformDatiAnnotazioneList } from 'civil-status/utils/transformer-act-wizard-data-saved/transform-sections';
import {
  keyIdConsenso,
  keyIdDatiEventoRiconoscimento,
  keyRiconoscimentoList,
} from 'civil-status/constants/update-id-step';
import { STATES_NOTIFICATIONS } from 'civil-status/constants/states-notifications';
import { titleMotherFather } from 'civil-status/constants/title-mother-father';
import { ID_REGISTER } from 'civil-status/components/shared/list-register';

interface ActionsFormProps {
  formContext: FormikProps<StepVM>;
  currentStep?: number;
  idActGemelloSuccessivo?: number;
  tipoEvento?: string;
  goBack: () => void;
  onClickNotification: (isConfirm?: boolean) => void;
  onSave: (values: StepVM) => ResponsePromise<DataWizardAct | undefined | void> | void;
  onClickValid: () => void;
  onClickEditAct: (values?: SectionVM) => void;
  onClickPreview: () => void;
  deleteEvent: () => void;
  backCompilation: (values?: SignatureActUscVM) => void;
  onClickVerify: (values?: SignatureActVM) => void | ResponsePromise<number>;
  signatureUSC: () => void;
  onYesPreview: (idAnsc?: string) => void;
  onPrintAct: () => void;
  onConfirmRegistration: () => void;
  setRecap: (state: Array<RecapVM>) => void;
  onClickPrintCommunication: (communicationValues?: CommunicationVM) => void;
  onParent: (values: ViewStepVM, title?: string) => void;
  onOther: () => void;
  onCohabitation: () => void;
  onRegisterDeath: (values: ViewStepVM, isNonResidente?: boolean) => void;
  onRegisterBirth: (values: ViewStepVM) => void;
  onRegisterCitizenship: (values: ViewStepVM) => void;
  onRegisterMarriageCivilUnion: (
    values: ViewStepVM,
    isCivilUnion?: boolean,
    isNonResidente?: boolean
  ) => void;
  goBackNotification: () => void;
  onCancelNotification: () => void;
  transcribeOath: (idEvento?: number) => void;
  onForwardCertificateConformity: (values: SignatureActUscVM) => void;
  recap?: Array<RecapVM>;
  isLastStep?: boolean;
  isLastStepEmergency?: boolean;
  isLastStepEdit?: boolean;
  isSignatureAct?: boolean;
  isSignatureUSC?: boolean;
  disabled?: boolean;
  isView?: boolean;
  isNotifications?: boolean;
  isNotificationsAnsc?: boolean;
  isCommunications?: boolean;
  withErrors?: boolean;
  disabledValid?: boolean;
  disabledEmergency?: boolean;
  disabledConfirmRegistration?: boolean;
  isCertificateConformity?: boolean;
  isCertificateConformityWithoutSubjects?: boolean;
  isStepFromEmergency?: boolean;
  idEvento?: number;
  stateNotification?: string;
  isDetailAcquisitionNotifications?: boolean;
  isEditAcquisitionNotifications?: boolean;
  disabledCertificateConformityWithoutAct?: boolean;
  disabledForwardCertificateConformity?: boolean;
  isStepFromEmergencyConfirm?: boolean;
  isLastStepEditAct?: boolean;
  idNotifica?: string;
}

const ActionsFormComponent = ({
  formContext,
  goBack,
  onClickNotification,
  onSave,
  onClickValid,
  onClickEditAct,
  onClickPreview,
  deleteEvent,
  backCompilation,
  onClickVerify,
  signatureUSC,
  onYesPreview,
  onPrintAct,
  onConfirmRegistration,
  onClickPrintCommunication,
  setRecap,
  onParent,
  onOther,
  onCohabitation,
  onRegisterDeath,
  onRegisterCitizenship,
  onRegisterMarriageCivilUnion,
  goBackNotification,
  onCancelNotification,
  transcribeOath,
  onForwardCertificateConformity,
  recap = [],
  disabled = false,
  isLastStep = false,
  isLastStepEmergency = false,
  isLastStepEdit = false,
  isSignatureAct = false,
  isSignatureUSC = false,
  isView = false,
  withErrors = false,
  disabledValid = false,
  disabledEmergency = false,
  disabledConfirmRegistration = false,
  isCertificateConformity = false,
  isCertificateConformityWithoutSubjects = false,
  isNotifications = false,
  isNotificationsAnsc = false,
  isCommunications = false,
  isDetailAcquisitionNotifications = false,
  isEditAcquisitionNotifications = false,
  disabledCertificateConformityWithoutAct = false,
  disabledForwardCertificateConformity = false,
  isStepFromEmergency = false,
  isStepFromEmergencyConfirm = false,
  isLastStepEditAct = false,
  idActGemelloSuccessivo,
  idEvento,
  tipoEvento,
  stateNotification,
  onRegisterBirth,
}: ActionsFormProps): React.ReactElement => {
  const navigate = useNavigate();
  const [openModalTwins, setOpenModalTwins] = useState<boolean>(false);

  const values = useMemo(() => {
    return formContext.values || {};
  }, [formContext.values]);

  const idTipoEvento: string = useMemo(() => {
    return (values as ViewStepVM)?.head?.idTipoEvento || '';
  }, [(values as ViewStepVM)?.head?.idTipoEvento]);

  const bookTwins = useHttpClient(`${__ACT_API_URL__}/bozza/prenotazione/${idEvento}`, {
    options: {
      method: 'POST',
      loading: true,
      errorCatching: true,
    },
  });

  const [disabledBookTwins, setDisabledBookTwins] = useState({
    disabled: true,
    isBookTwins: false, // true => quando viene effettuata la prenotazione
    keyWithTwins: '', // contiene il valore della chiave dell'oggetto dei gemelli
  });

  const controllTwins = useEventCallback(() => {
    // si abilita solo se è il primo gemello e non sono stati prenotati
    if (disabledBookTwins.isBookTwins || !disabledBookTwins.disabled) {
      return;
    }

    const keysValues = Object.keys(values);

    keysValues.forEach((keyItem) => {
      const dataSubject = values[keyItem] as ParentVM;

      if (dataSubject?.generality?.isBookTwins) {
        setDisabledBookTwins({
          disabled: true,
          isBookTwins: true,
          keyWithTwins: keyItem || '',
        });

        return;
      }

      if (dataSubject?.generality?.isWithTwins && dataSubject?.generality?.currentTwin === 1) {
        setDisabledBookTwins({
          disabled: false,
          isBookTwins: false,
          keyWithTwins: keyItem || '',
        });
      }
    });
  });

  useEffect(() => {
    // al variare dei dati aggiorniamo i controlli per i gemelli
    controllTwins();
  }, [values]);

  useEffect(() => {
    // controllo iniziale per i gemelli
    controllTwins();
  }, []);

  const onBookTwins = useEventCallback(() => {
    if (!idEvento) {
      return;
    }

    (bookTwins() as unknown as ResponsePromise<HttpResponse<Evento>>).then((response) => {
      toast.success('Operazione eseguita con successo');

      const idAnsc = response?.data.payload?.idAnsc;

      if (idAnsc) {
        setRecap(recap.map((item) => ({ ...item, idAnsc })));
      }

      formContext.setValues({
        ...values,
        [disabledBookTwins.keyWithTwins]: {
          ...(values[disabledBookTwins.keyWithTwins] || {}),
          generality: {
            ...((values[disabledBookTwins.keyWithTwins] as ParentVM)?.generality || {}),
            isBookTwins: true,
          },
        } as ParentVM,
      });

      setDisabledBookTwins({
        disabled: true,
        isBookTwins: true,
        keyWithTwins: disabledBookTwins.keyWithTwins,
      });
    });
  });

  const onClickSave = useEventCallback(async (withValid?: boolean, withEditAct?: boolean) => {
    if (isLastStep) {
      // controllo dati obbligatori
      let touched: FormikTouched<StepVM> = {};

      Object.keys(values).forEach((itemKey) => {
        let touchedItem = {};

        if (itemKey.includes('subject')) {
          touchedItem = {
            [itemKey]: {
              ...touchedSubject,
            },
          } as unknown as FormikTouched<ParentVM>;
        }

        if (itemKey.includes('section')) {
          touchedItem = {
            [itemKey]: {
              ...touchedSection,
            },
          } as unknown as FormikTouched<ParentVM>;
        }

        touched = {
          ...(touched || {}),
          ...touchedItem,
        } as unknown as FormikTouched<StepVM>;
      });

      formContext.setTouched(touched);
    }

    if (withErrors && isLastStep) {
      // se è presente errore non effettuare chiamata e segnalarli con il setTouched
      return;
    }

    try {
      onSave(values)?.then((response) => {
        const res = (response || undefined) as DataWizardAct | undefined;

        if (!isLastStep) {
          return;
        }

        const valuesLastStep = (values || {}) as LastStepVM;

        let allNewValues: LastStepVM = { ...valuesLastStep };

        const castedResponseSoggettoList = res?.soggettoList || [];

        castedResponseSoggettoList?.forEach((item) => {
          const keySubject = `subject-${item.codiceSoggetto}`;

          allNewValues[keySubject] = {
            ...((allNewValues[keySubject] as ParentVM) || {}),
            isSaved: true,
            generality: {
              ...((allNewValues[keySubject] as ParentVM)?.generality || {}),
              idSubject: item.key.idSoggetto || undefined,
            },
          } as ParentVM;
        });

        const castedResponseCertificatoSanitario = res?.certificatoSanitario || {};
        const castedResponseDatiEventoRiconoscimento = res?.datiEventoRiconoscimento || {};
        const castedResponseConsenso = res?.consenso || {};
        const castedResponseEnteDichiaranteList = res?.enteDichiaranteList || [];
        const castedResponseAttoCollegatoList = res?.attoCollegatoList || [];
        const castedResponseLuogo = res?.luogo || {};
        const castedDatiAnnotazioneList = res?.datiAnnotazioneList || [];
        const castedImpedimentoList = res?.impedimentoList || [];
        const castedRegimePatrimoniale = res?.regimePatrimoniale || {};
        const castedPubblicazioneList = res?.pubblicazioneList || [];
        const castedRiconoscimentoList = res?.riconoscimentoList || {};
        const castedStatoCivile = res?.statoCivile || {};
        const castedEvento = res?.evento || {};

        if (allNewValues[KeySections.keyDatiRegistroEmergenza]) {
          allNewValues[KeySections.keyDatiRegistroEmergenza] = {
            ...((allNewValues[KeySections.keyDatiRegistroEmergenza] as SectionVM) || {}),
            isSaved: true,
            number:
              castedStatoCivile?.numeroAttoRdE ||
              (allNewValues[KeySections.keyDatiRegistroEmergenza] as SectionVM).number ||
              undefined,
            identifier: castedEvento?.idAttoCartaceo || undefined,
          } as SectionVM;
        }

        if (allNewValues[KeySections.keyDatiGeneraliRiconoscimento]) {
          allNewValues[KeySections.keyDatiGeneraliRiconoscimento] = {
            ...((allNewValues[KeySections.keyDatiGeneraliRiconoscimento] as SectionVM) || {}),
            isSaved: true,
            idCertSanitario: castedResponseCertificatoSanitario.key?.idCertSanitario || undefined,
          } as SectionVM;
        }

        if (allNewValues[KeySections.keyAutorizzazioneRiconoscimentoPadre]) {
          allNewValues[KeySections.keyAutorizzazioneRiconoscimentoPadre] = {
            ...((allNewValues[KeySections.keyAutorizzazioneRiconoscimentoPadre] as SectionVM) ||
              {}),
            isSaved: true,
            idCertSanitario: castedResponseCertificatoSanitario.key?.idCertSanitario || undefined,
          } as SectionVM;
        }

        const keyChangeIdDatiEventoRiconoscimento = keyIdDatiEventoRiconoscimento.filter(
          (itemKey) => Boolean(allNewValues[itemKey])
        );

        keyChangeIdDatiEventoRiconoscimento.forEach((itemKeyIdDatiEventoRiconoscimento) => {
          if (itemKeyIdDatiEventoRiconoscimento.includes('subject')) {
            // se soggetto
            allNewValues[itemKeyIdDatiEventoRiconoscimento] = {
              ...((allNewValues[itemKeyIdDatiEventoRiconoscimento] as ParentVM) || {}),
              isSaved: true,
              generality: {
                ...((allNewValues[itemKeyIdDatiEventoRiconoscimento] as ParentVM) || {}).generality,
                idDatiEventoRiconoscimento:
                  castedResponseDatiEventoRiconoscimento.key?.idDatiEventoRiconoscimento,
              },
            } as ParentVM;
          } else {
            // se sezione
            allNewValues[itemKeyIdDatiEventoRiconoscimento] = {
              ...((allNewValues[itemKeyIdDatiEventoRiconoscimento] as SectionVM) || {}),
              isSaved: true,
              idDatiEventoRiconoscimento:
                castedResponseDatiEventoRiconoscimento.key?.idDatiEventoRiconoscimento,
            } as SectionVM;
          }
        });

        const keyChangeIdConsenso = keyIdConsenso.filter((itemKey) =>
          Boolean(allNewValues[itemKey])
        );

        keyChangeIdConsenso.forEach((itemKeyIdConsenso) => {
          allNewValues[itemKeyIdConsenso] = {
            ...((allNewValues[itemKeyIdConsenso] as SectionVM) || {}),
            isSaved: true,
            idConsenso: castedResponseConsenso.key?.idConsenso,
          } as SectionVM;
        });

        const keyChangeRiconoscimentoList = keyRiconoscimentoList.filter((itemKey) =>
          Boolean(allNewValues[itemKey])
        );

        keyChangeRiconoscimentoList.forEach((itemKeyRiconoscimentoList) => {
          allNewValues[itemKeyRiconoscimentoList] = {
            ...((allNewValues[itemKeyRiconoscimentoList] as SectionVM) || {}),
            isSaved: true,
            riconoscimentoList: castedRiconoscimentoList,
          } as SectionVM;
        });

        const keyAllNewValues = Object.keys(allNewValues || {});

        // Settare gli id delle liste
        keyAllNewValues.forEach((item) => {
          const currentValuesItem: SectionVM | undefined = allNewValues[item] as SectionVM;

          const attoCollegato = castedResponseAttoCollegatoList.find(
            (itemAtto) => itemAtto.sezione?.trim() === currentValuesItem?.codeSection
          );

          const enteDichiarante = castedResponseEnteDichiaranteList.find(
            (itemEnteDichiarante) =>
              itemEnteDichiarante.sezione?.trim() === currentValuesItem?.codeSection
          );

          const currentEnteDichiaranteCodSezione = enteDichiarante?.sezione?.trim();

          const itemKeyCurrent = currentValuesItem?.codeSection;

          const isCurrentUltimoLuogo =
            itemKeyCurrent === CodeSection.ULTIMO_LUOGO ||
            itemKeyCurrent === CodeSection.DATI_SPECIFICI_UNICIV;

          allNewValues[item] = {
            ...(allNewValues[item] || {}),
            idAttoCollegato: attoCollegato
              ? attoCollegato?.key?.idAttoCollegato
              : currentValuesItem.idAttoCollegato,
            idEnteDichiarante: enteDichiarante
              ? enteDichiarante?.key?.idEnteDichiarante
              : currentValuesItem.idEnteDichiarante,
            idCertificato:
              castedImpedimentoList.find(
                (itemImpedimento) => itemImpedimento.sezione === currentEnteDichiaranteCodSezione
              )?.idCertificato || undefined,
            idImpedimento:
              castedImpedimentoList.find(
                (itemImpedimento) => itemImpedimento.sezione === currentEnteDichiaranteCodSezione
              )?.key?.idImpedimento || undefined,
            idLuogo: isCurrentUltimoLuogo
              ? castedResponseLuogo.key?.idLuogo || currentValuesItem.idLuogo
              : undefined,
          } as SectionVM;
        });

        if (castedDatiAnnotazioneList.length) {
          allNewValues = {
            ...(allNewValues || {}),
            ...transformDatiAnnotazioneList(castedDatiAnnotazioneList),
          };
        }

        if (castedPubblicazioneList.length) {
          castedPubblicazioneList.forEach((itemCastedPubblicazione) => {
            if (itemCastedPubblicazione.codiceSezione === CodeSection.PUBBLICAZIONE_1) {
              allNewValues[KeySections.keyPubblicazione1] = {
                ...(values[KeySections.keyPubblicazione1] || {}),
                idPubblicazione: itemCastedPubblicazione.key?.idPubblicazione,
              };
            }

            if (itemCastedPubblicazione.codiceSezione === CodeSection.PUBBLICAZIONE_2) {
              allNewValues[KeySections.keyPubblicazione2] = {
                ...(values[KeySections.keyPubblicazione2] || {}),
                idPubblicazione: itemCastedPubblicazione.key?.idPubblicazione,
              };
            }
          });
        }

        if (allNewValues[KeySections.keyRegimePatrimoniale]) {
          allNewValues[KeySections.keyRegimePatrimoniale] = {
            ...((allNewValues[KeySections.keyRegimePatrimoniale] as SectionVM) || {}),
            idRegimePatrimoniale: castedRegimePatrimoniale.key?.idRegimePatrimoniale || null,
          } as SectionVM;
        }

        formContext.setValues(allNewValues as unknown as StepVM);

        if (withValid) {
          onClickValid();
        }

        const valuesAttoDaRettificare = valuesLastStep[
          KeySections.keyAttoDaRettificare
        ] as SectionVM;

        if (withEditAct && valuesAttoDaRettificare) {
          onClickEditAct(valuesAttoDaRettificare);
        }
      });
    } catch (error) {}
  });

  const disabledBackCompilation = useMemo(() => {
    const castedValues = (values || {}) as SignatureActVM;

    if (isCertificateConformity) {
      return castedValues.idState?.toString() !== STATES_ACT.ID_STATE_CONFERMATO;
    }

    // se è iniziata la fase di compilazione disabilitare il bottone
    if (Boolean(castedValues.document?.idAnscAllegato || castedValues.document?.raw)) {
      // inviato documento per firma autografa o documento caricato in SIDE
      return true;
    }

    if (Boolean(castedValues.signatories?.find((item) => Boolean(item.idPresaVisione)))) {
      // inviata la firma digitale
      return true;
    }

    return false;
  }, [values, isCertificateConformity]);

  const disabledVerify = useMemo(() => {
    if (!isSignatureAct) {
      return true;
    }

    const castedValues = (values || {}) as SignatureActVM;

    // firma incompleta digitale
    const incompleteSignatureDigital = Boolean(
      castedValues.signatories?.find((item) => !item.isAutografa && !item.isVerify)
    );

    // firma incopleta autografa
    const incompleteSignatureAutographs =
      Boolean(castedValues.document?.raw) &&
      castedValues.document?.codStato !== idStateDocumentWizard.Inserito;

    if (incompleteSignatureDigital || incompleteSignatureAutographs) {
      // firme non complete
      return true;
    }

    return castedValues.idState?.toString() === STATES_ACT.ID_STATE_FIRMA_DICHIARANTE;
  }, [values, isSignatureAct]);

  const disabledSignatureUSC = useMemo(() => {
    if (!isSignatureAct) {
      return true;
    }

    const castedValues = (values || {}) as SignatureActVM;

    return castedValues.idState?.toString() !== STATES_ACT.ID_STATE_FIRMA_DICHIARANTE;
  }, [values, isSignatureAct]);

  const disabledNotification = useMemo(() => {
    return (
      stateNotification === STATES_NOTIFICATIONS.ID_STATE_APPROVATO ||
      stateNotification === STATES_NOTIFICATIONS.ID_STATE_RIFIUTATA
    );
  }, [stateNotification]);

  const onVerify = useEventCallback(() => {
    const castedValues = values as SignatureActVM;
    onClickVerify(castedValues)?.then((res) => {
      const idStatoEvento = res as number | undefined;

      formContext.setFieldValue('idState', idStatoEvento);
    });
  });

  const onClickGemello = useEventCallback(() => {
    if (!idActGemelloSuccessivo) {
      return;
    }

    navigate(
      generatePath('/stato-civile/ricerca-atto-da-compilare/modifica/:idEvento', {
        idEvento: idActGemelloSuccessivo?.toString(),
      }),
      { replace: true }
    );
  });

  const isVisibleBackCompilation = useMemo(() => {
    if (isSignatureAct) {
      return true;
    }

    if (isCertificateConformityWithoutSubjects) {
      return true;
    }

    const castedValues = (values || {}) as SignatureActVM;

    return castedValues.idState?.toString() === STATES_ACT.ID_STATE_CONFERMATO;
  }, [isSignatureAct, values, isCertificateConformityWithoutSubjects]);

  if (isStepFromEmergency) {
    return (
      <Grid item xs={12} display="flex" justifyContent="center">
        <PmiButton
          color="cdmBrand"
          variant="outlined"
          onClick={goBack}
          style={{ marginRight: '1rem' }}
        >
          Torna alla lista
        </PmiButton>
        <PmiButton
          color="cdmBrandThird"
          variant="outlined"
          onClick={() => onClickValid()}
          disabled={disabledValid}
          style={{ marginRight: '1rem' }}
        >
          Valida evento
        </PmiButton>
        <PmiButton
          color="cdmBrandThird"
          variant="outlined"
          onClick={onClickPreview}
          disabled={disabled}
        >
          Anteprima
        </PmiButton>
      </Grid>
    );
  }

  // NOTIFICHE - NASCITA
  if (isEditAcquisitionNotifications && idTipoEvento === ID_REGISTER.NASCITA) {
    return (
      <Grid item xs={12} display="flex" justifyContent="center">
        {/* {(values as ViewStepVM)?.holders
          ?.filter((holder) => holder?.title?.includes('Intestatario'))
          ?.every(
            (holder) =>
              holder?.idComuneResidenza &&
              (holder?.idComuneResidenza === ISTAT_MILANO ||
                holder?.idComuneResidenza === ISTAT_MILANO_2)
          ) ? undefined : (
          <PmiButton
            color="cdmBrandThird"
            variant="outlined"
            onClick={() => onRegisterBirth(values as ViewStepVM)}
            style={{ marginRight: '1rem' }}
          >
            Registra Non residente
          </PmiButton>
        )} */}
        <PmiButton
          color="cdmBrandThird"
          variant="outlined"
          onClick={() => onParent(values as ViewStepVM)}
          style={{ marginRight: '1rem' }}
        >
          Genitori
        </PmiButton>
        <PmiButton
          color="cdmBrandThird"
          variant="outlined"
          onClick={() => onParent(values as ViewStepVM, titleMotherFather.Madre)}
          style={{ marginRight: '1rem' }}
        >
          Madre
        </PmiButton>
        <PmiButton
          color="cdmBrandThird"
          variant="outlined"
          onClick={() => onParent(values as ViewStepVM, titleMotherFather.Padre)}
          style={{ marginRight: '1rem' }}
        >
          Padre
        </PmiButton>
        <PmiButton
          color="cdmBrandThird"
          variant="outlined"
          onClick={onOther}
          style={{ marginRight: '1rem' }}
        >
          Altra
        </PmiButton>
        <PmiButton
          color="cdmBrandThird"
          variant="outlined"
          onClick={onCohabitation}
          style={{ marginRight: '1rem' }}
        >
          Convivenza
        </PmiButton>
        <PmiButton
          color="cdmBrandThird"
          variant="outlined"
          onClick={() => onRegisterBirth(values as ViewStepVM)}
          style={{ marginRight: '1rem' }}
        >
          Registra Non residente
        </PmiButton>
        <PmiButton
          color="cdmBrand"
          variant="outlined"
          onClick={onCancelNotification}
          style={{ marginRight: '1rem' }}
        >
          Annulla
        </PmiButton>
        <PmiButton color="cdmBrand" variant="outlined" onClick={goBackNotification}>
          Indietro
        </PmiButton>
      </Grid>
    );
  }

  // NOTIFICHE - MORTE - MATRIMONIO
  if (
    isEditAcquisitionNotifications &&
    (idTipoEvento === ID_REGISTER.MORTE ||
      idTipoEvento === ID_REGISTER.MATRIMONIO ||
      idTipoEvento === ID_REGISTER.UNIONE_CIVILE ||
      idTipoEvento === ID_REGISTER.CITTADINANZA)
  ) {
    return (
      <Grid item xs={12} display="flex" justifyContent="center">
        {/* <PmiButton
          color="cdmBrandThird"
          variant="outlined"
          onClick={() => {
            if (idTipoEvento === ID_REGISTER.MATRIMONIO) {
              onRegisterMarriageCivilUnion(values as ViewStepVM);
              return;
            }

            if (idTipoEvento === ID_REGISTER.UNIONE_CIVILE) {
              onRegisterMarriageCivilUnion(values as ViewStepVM, true);
              return;
            }

            if (idTipoEvento === ID_REGISTER.MORTE) {
              onRegisterDeath(values as ViewStepVM);
              return;
            }

            if (idTipoEvento === ID_REGISTER.CITTADINANZA) {
              onRegisterCitizenship(values as ViewStepVM);
            }
          }}
          style={{ marginRight: '1rem' }}
        >
          {idTipoEvento !== ID_REGISTER.MATRIMONIO &&
          idTipoEvento !== ID_REGISTER.UNIONE_CIVILE &&
          idTipoEvento !== ID_REGISTER.MORTE
            ? 'Registra'
            : (values as ViewStepVM)?.holders?.every((holder) => !isResidenceMilano(holder))
            ? 'Registra non residente'
            : 'Registra'}
        </PmiButton> */}
        <PmiButton
          color="cdmBrandThird"
          variant="outlined"
          onClick={() => {
            if (idTipoEvento === ID_REGISTER.MATRIMONIO) {
              onRegisterMarriageCivilUnion(values as ViewStepVM);
              return;
            }

            if (idTipoEvento === ID_REGISTER.UNIONE_CIVILE) {
              onRegisterMarriageCivilUnion(values as ViewStepVM, true);
              return;
            }

            if (idTipoEvento === ID_REGISTER.MORTE) {
              onRegisterDeath(values as ViewStepVM);
              return;
            }

            if (idTipoEvento === ID_REGISTER.CITTADINANZA) {
              onRegisterCitizenship(values as ViewStepVM);
            }
          }}
          style={{ marginRight: '1rem' }}
        >
          Registra
        </PmiButton>
        <PmiButton
          color="cdmBrandThird"
          variant="outlined"
          onClick={() => {
            if (idTipoEvento === ID_REGISTER.MATRIMONIO) {
              onRegisterMarriageCivilUnion(values as ViewStepVM, false, true);
              return;
            }

            if (idTipoEvento === ID_REGISTER.UNIONE_CIVILE) {
              onRegisterMarriageCivilUnion(values as ViewStepVM, true, true);
              return;
            }

            if (idTipoEvento === ID_REGISTER.MORTE) {
              onRegisterDeath(values as ViewStepVM, true);
              return;
            }

            if (idTipoEvento === ID_REGISTER.CITTADINANZA) {
              onRegisterCitizenship(values as ViewStepVM);
            }
          }}
          style={{ marginRight: '1rem' }}
        >
          Registra non residente
        </PmiButton>
        <PmiButton
          color="cdmBrand"
          variant="outlined"
          onClick={onCancelNotification}
          style={{ marginRight: '1rem' }}
        >
          Annulla
        </PmiButton>
        <PmiButton color="cdmBrand" variant="outlined" onClick={goBackNotification}>
          Indietro
        </PmiButton>
      </Grid>
    );
  }

  if (isDetailAcquisitionNotifications) {
    return (
      <Grid item xs={12} display="flex" justifyContent="center">
        <PmiButton color="cdmBrand" variant="outlined" onClick={goBack}>
          Indietro
        </PmiButton>
      </Grid>
    );
  }

  if (isCommunications) {
    return (
      <Grid item xs={12} display="flex" justifyContent="center">
        <PmiButton
          color="cdmBrand"
          variant="outlined"
          onClick={goBack}
          style={{ marginRight: '1rem' }}
        >
          Indietro
        </PmiButton>
        <PmiButton
          color="cdmBrandThird"
          variant="outlined"
          onClick={() => onClickPrintCommunication((values as ViewStepVM)?.comunication)}
        >
          Stampa
        </PmiButton>
      </Grid>
    );
  }

  return (
    <Grid item xs={12} display="flex" justifyContent="center">
      {isVisibleBackCompilation ? (
        <PmiButton
          color="cdmBrandThird"
          variant="outlined"
          onClick={() => backCompilation(values as SignatureActUscVM)}
          style={{ marginRight: '1rem' }}
          disabled={disabled || disabledBackCompilation || isStepFromEmergencyConfirm}
        >
          Torna alla compilazione
        </PmiButton>
      ) : undefined}
      {isLastStepEditAct ? undefined : (
        <PmiButton
          color="cdmBrand"
          variant="outlined"
          onClick={deleteEvent}
          style={{ marginRight: '1rem' }}
          disabled={disabled}
        >
          Elimina evento
        </PmiButton>
      )}
      {isSignatureUSC || isView ? (
        <PmiButton
          color="cdmBrandThird"
          variant="outlined"
          onClick={() => onYesPreview(isView ? (values as ViewStepVM).idAnsc : undefined)}
          style={{ marginRight: '1rem' }}
        >
          Anteprima
        </PmiButton>
      ) : undefined}
      {isView && (values as ViewStepVM)?.head?.idUC === '51106' ? (
        <PmiButton
          color="cdmBrandThird"
          variant="outlined"
          onClick={() => transcribeOath((values as ViewStepVM)?.idEvento)}
          style={{ marginRight: '1rem' }}
          disabled={
            !Boolean((values as ViewStepVM)?.idEvento) ||
            Boolean((values as ViewStepVM)?.idEventoCorrelato)
          }
        >
          Trascrivi giuramento
        </PmiButton>
      ) : undefined}
      {isSignatureUSC || isCertificateConformity || isCertificateConformityWithoutSubjects ? (
        <PmiButton
          color="cdmBrandThird"
          variant="outlined"
          type="submit"
          style={{ marginRight: '1rem' }}
          disabled={
            isCertificateConformity || isCertificateConformityWithoutSubjects
              ? disabledCertificateConformityWithoutAct
              : false
          }
        >
          Firma
        </PmiButton>
      ) : undefined}
      {isCertificateConformity || isCertificateConformityWithoutSubjects ? (
        <PmiButton
          color="cdmBrandThird"
          variant="outlined"
          style={{ marginRight: '1rem' }}
          onClick={() => onForwardCertificateConformity(values)}
          disabled={disabledForwardCertificateConformity}
        >
          Continua
        </PmiButton>
      ) : undefined}
      {isSignatureAct ? (
        <Fragment>
          <PmiButton
            color="cdmBrandThird"
            variant="outlined"
            onClick={onVerify}
            style={{ marginRight: '1rem' }}
            disabled={disabled || disabledVerify}
          >
            Verifica stato evento
          </PmiButton>
          <PmiButton
            color="cdmBrandThird"
            variant="outlined"
            onClick={signatureUSC}
            disabled={disabled || disabledSignatureUSC}
          >
            Firma USC
          </PmiButton>
        </Fragment>
      ) : undefined}
      {isSignatureAct ||
      isSignatureUSC ||
      isCertificateConformity ||
      isCertificateConformityWithoutSubjects ? undefined : (
        <Fragment>
          <PmiButton
            color="cdmBrand"
            variant="outlined"
            onClick={goBack}
            style={{ marginRight: '1rem' }}
          >
            Indietro
          </PmiButton>
          {isNotificationsAnsc ? (
            <Fragment>
              <PmiButton
                color="cdmBrandThird"
                variant="outlined"
                onClick={() => onClickNotification(true)}
                style={{ marginRight: '1rem' }}
                disabled={disabledNotification}
              >
                Accetta
              </PmiButton>
              <PmiButton
                color="cdmBrand"
                variant="outlined"
                disabled={disabledNotification}
                onClick={() => onClickNotification(false)}
                style={{ marginRight: '1rem' }}
              >
                Rifiuta
              </PmiButton>
            </Fragment>
          ) : undefined}
          {isLastStep ||
          isSignatureAct ||
          isSignatureUSC ||
          isCertificateConformity ||
          isCertificateConformityWithoutSubjects ||
          isNotifications ? undefined : (
            <PmiButton
              color="cdmBrandThird"
              variant="outlined"
              type="submit"
              style={{ marginRight: '1rem' }}
              disabled={disabled}
            >
              Avanti
            </PmiButton>
          )}
          {isSignatureAct || isSignatureUSC || isNotifications ? undefined : (
            <PmiButton
              color="cdmBrandThird"
              variant="outlined"
              onClick={() => onClickSave()}
              style={{ marginRight: isLastStep || Boolean(idActGemelloSuccessivo) ? '1rem' : '' }}
              disabled={disabled || (values.textAct as TextActVM)?.isEditText}
            >
              Salva
            </PmiButton>
          )}
          {isLastStepEmergency ? (
            <Fragment>
              <PmiButton
                color="cdmBrandThird"
                variant="outlined"
                onClick={() => onPrintAct()}
                disabled={disabledEmergency}
                style={{ marginRight: '1rem' }}
              >
                Stampa atto
              </PmiButton>
              <PmiButton
                color="cdmBrandThird"
                variant="outlined"
                onClick={() => onConfirmRegistration()}
                disabled={disabledConfirmRegistration}
                style={{ marginRight: '1rem' }}
              >
                Conferma registrazione
              </PmiButton>
            </Fragment>
          ) : undefined}
          {isLastStep ? (
            <Fragment>
              {tipoEvento === '1' && !isLastStepEdit ? (
                <PmiButton
                  color="cdmBrandThird"
                  variant="outlined"
                  onClick={() => setOpenModalTwins(true)}
                  style={{ marginRight: '1rem' }}
                  disabled={disabledBookTwins.disabled || disabledBookTwins.isBookTwins}
                >
                  Prenota gemelli
                </PmiButton>
              ) : undefined}
              <PmiButton
                color="cdmBrandThird"
                variant="outlined"
                onClick={() => (isLastStepEdit ? onClickSave(false, true) : onClickSave(true))}
                disabled={disabledValid || disabled || isLastStepEmergency}
                style={{ marginRight: '1rem' }}
              >
                {isLastStepEdit ? 'Procedi alla rettifica' : 'Valida evento'}
              </PmiButton>
              <PmiButton
                color="cdmBrandThird"
                variant="outlined"
                onClick={onClickPreview}
                disabled={disabled}
              >
                Anteprima
              </PmiButton>
            </Fragment>
          ) : undefined}
          {idActGemelloSuccessivo ? (
            <PmiButton
              color="cdmBrandThird"
              variant="outlined"
              onClick={() => onClickGemello()}
              style={{ marginRight: '1rem' }}
            >
              Compila gemello successivo
            </PmiButton>
          ) : undefined}
        </Fragment>
      )}
      {openModalTwins ? (
        <DeleteAlertModal
          title="Attenzione"
          message="Una volta prenotati i numeri degli atti dei gemelli non è più possibile modificarne il numero. Confermi la prenotazione?"
          open={openModalTwins}
          onClose={() => setOpenModalTwins(false)}
          onYes={() => {
            setOpenModalTwins(false);
            onBookTwins();
          }}
          onNo={() => setOpenModalTwins(false)}
        />
      ) : undefined}
    </Grid>
  );
};

ActionsFormComponent.displayName = 'Actions Form Component';

const ActionsForm = memo(ActionsFormComponent);

export default ActionsForm;
